export default __webpack_public_path__ + "static/images/logo-satispay-94b9425040beee522f7e248469c92e18.png";